export class WarehouseLineAllocationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAllocationsByLine({ lineId }) {
    return this.#http.get(`/api/warehouse-lines/${lineId}/allocations`);
  }

  async getAllocationsByLineFiltered({ lineId, status }) {
    return this.#http.get(`/api/warehouse-lines/${lineId}/allocations`, { params: { status } });
  }

  async getAllocation({ allocationId }) {
    return this.#http.get(`/api/allocations/${allocationId}`);
  }

  async getAllocationByLoan({ loanId }) {
    return this.#http.get(`/api/loans/${loanId}/allocation`);
  }

  async createAllocation({ lineId, ...body }) {
    return this.#http.post(`/api/warehouse-lines/${lineId}/allocations`, body);
  }

  async updateAllocation({ allocationId, ...body }) {
    return this.#http.put(`/api/allocations/${allocationId}`, body);
  }

  async deleteAllocation({ allocationId }) {
    return this.#http.delete(`/api/allocations/${allocationId}`);
  }

  async transitionAllocationStatus({ allocationId, ...body }) {
    return this.#http.post(`/api/allocations/${allocationId}/transition`, body);
  }

  async getEligibleLines({ warehouseBankId, params }) {
    return this.#http.get(`/api/warehouse-banks/${warehouseBankId}/eligible-lines`, { params });
  }

  async getCurtailments({ allocationId }) {
    return this.#http.get(`/api/allocations/${allocationId}/curtailments`);
  }

  async createCurtailment({ allocationId, ...body }) {
    return this.#http.post(`/api/allocations/${allocationId}/curtailments`, body);
  }

  async updateCurtailment({ curtailmentId, ...body }) {
    return this.#http.put(`/api/curtailments/${curtailmentId}`, body);
  }

  async recordCurtailmentPayment({ curtailmentId, ...body }) {
    return this.#http.post(`/api/curtailments/${curtailmentId}/payment`, body);
  }

  async getUpcomingCurtailments(params) {
    return this.#http.get('/api/curtailments/upcoming', { params });
  }

  async getCurtailmentRules({ lineId }) {
    return this.#http.get(`/api/warehouse-lines/${lineId}/curtailment-rules`);
  }

  async manageCurtailmentRules({ lineId, rules }) {
    return this.#http.put(`/api/warehouse-lines/${lineId}/curtailment-rules`, rules);
  }

  async getBankConfiguration({ warehouseBankId }) {
    return this.#http.get(`/api/warehouse-banks/${warehouseBankId}/configuration`);
  }

  async updateBankConfiguration({ warehouseBankId, ...body }) {
    return this.#http.put(`/api/warehouse-banks/${warehouseBankId}/configuration`, body);
  }

  async getLineAllocationSettings({ lineId }) {
    return this.#http.get(`/api/warehouse-lines/${lineId}/allocation-settings`);
  }

  async updateLineAllocationSettings({ lineId, ...body }) {
    return this.#http.put(`/api/warehouse-lines/${lineId}/allocation-settings`, body);
  }
}
